import Button from "../../../../../common/ekedc-components/button/Button";
import styles from "./StepFooter.module.scss";

interface StepFooterProps {
	text: string;
	onClick?: () => void;
	type?: "button" | "submit";
	form?: string;
	disabled?: boolean;
	loading?: boolean;
	loadingText?: string;
}

export const StepFooter = ({ text, onClick, type = "button", form, disabled, loading, loadingText }: StepFooterProps) => {
	return (
		<div className={styles.footer}>
			<Button
				text={text}
				variant="primary"
				type={type}
				form={form}
				onClick={onClick}
				disabled={disabled}
				loading={loading}
				loadingText={loadingText}
			/>
		</div>
	);
};
